import { url } from '../../../api/endpointURL';
import React, { useState } from 'react';

// error notification box
import './edit-modal.css';

// Import generic components
import Button from '../../../generic_components/Button/Button';
import Input from '../../../generic_components/Input/Input';
import { useToast } from '../../../generic_components/Toast/Toast';

const EditLATModal = ({ hwid, closeModal, site, setTableData, tableData }) => {
    const [lat, setLAT] = useState('');
    const[loading, setLoading] = useState(false);

    const toast = useToast();
        
    const handleUpdateLAT = async() => {
        try {
            if (!lat.trim()) {
                const errorMsg = `Please enter latitude.`;
                toast.error(errorMsg, {
                    hideProgressBar: true,
                    autoClose: 9000 
                });
                return;
            }
            const data = {hwid, lat};
            setLoading(true);
            const response = await fetch(`${url}/edit-lat`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (result.code === 200) {          
                const successMsg = `latitude updated to ${lat} successfully.`;
                toast.success(successMsg, {
                    hideProgressBar: true,
                    autoClose: 9000 
                });       
                // update setTableData with the new timezone
                const updatedTableData = tableData.map((item) => {
                    if (item.hwid === hwid) {
                        return { ...item, latitude: lat };
                    }
                    return item;
                });
                setTableData(updatedTableData);
            }
            // add delay of 1 second before closing the modal
            await new Promise(resolve => setTimeout(resolve, 1000));   
            setLoading(false);    
            closeModal();
            } catch(error) {
            console.log(`Error in updating LAT : ${error}`);
            }
    }

    const handleSelectChange = (e) => {
        setLAT(e.target.value.trim());
    }

  return (
    <div>
        <div className='modal-sites-body-title'>
            Enter latitude for the site {site}:
        </div>

        <Input
            className='modal-sites-body-input'
            type='text'
            value={lat}
            onChange={handleSelectChange} 
            placeholder='Enter latitude...'
            required 
            disabled={loading}
        />      
        <Button 
            size='small'
            className='modal-sites-body-btn-submit'
            onClick={() => handleUpdateLAT()}
            disabled={loading}  /* Disable when loading */
            >
            Update
        </Button>
        
        <div className='modal-sites-body-btn-loading-container'>
            { loading && (
                    <div className='loading-spinner'>
                        <div className="spinner-border modal-sites-body-loading-icon" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        </div>        
   
    </div>
    

  )
}

export default EditLATModal